/**
 * Featured collections Vue Component
 * ------------------------------------------------------------------------------
 * Main template in sections/index__featured-collections.liquid
 */
import VueTabs from './vue-tabs.vue'
import VueTab from './vue-tab.vue'
import ProductItem from './product-item.js'

export default {
  components: {
    VueTabs,
    VueTab,
    ProductItem
  },

  data () {
    return {

    }
  },

  methods: {

  }

}
